import Locale from "@/helper/locale/Locale.js";

export default {
    methods: {
        errorApi: function(err, callback) {
            let alertTitle = '';
            let alertMsg = '';
            let defalutCase = true;
            let errorId = err?.id != null ? err?.id : err?.code;
            let btnOk = '';

            let lbl = Locale.getLbl();

            if (errorId) {
                switch (errorId) {
                    case 401:
                        alertMsg = err.message;
                        break;
                    case 412:
                        alertMsg = "Token invalid";
                        defalutCase = false;
                        break;
                    case 1905:
                        alertTitle = lbl.token_expire.title;
                        alertMsg = lbl.token_expire.msg;
                        btnOk = lbl.token_expire.btn;
                        defalutCase = false;
                        break;
                    default:
                        alertMsg = err.message;
                        break;
                }
            } else {
                alertMsg = "Network connection error!";
            }

            if (typeof callback == 'function' && !defalutCase) {
                callback(err);
            }

            if (this.modal.errorModal != null && errorId) {
                if(alertTitle && btnOk){
                    this.modal.errorModal
                    .clearModal()
                    .setTitle(alertTitle)
                    .setMsg(alertMsg)
                    .setBtnOk(btnOk)
                    .setIsBtnWhite(true)
                    .show()
                }else{
                    this.modal.errorModal
                    .clearModal()
                    .setMsg(alertMsg)
                    .show()
                }

            }else{
                this.modal.noInternetModal.show();
            }
        },
    }
}
